import * as React from 'react'
import { IIntegration } from '../../../../../../types'
import FloatingForm from 'src/components/ui/form/FloatingForm'
import tr from '@mobiscroll/react/dist/src/i18n/tr'

export interface IProviderInfoItemProps {
  integration: IIntegration
}

// NOTE: Using IProviderListItemProps to expect riders membership
// We have to make these type consistent across the application

const ProductInfoPane = ({ integration }: IProviderInfoItemProps) => {
  return (
    <FloatingForm fullHeight={true}>
      <div className='form-modal-section full-section'>
        <div className='font-grey2 bold h5 mb1'>External API Integration</div>
        <div className='mt1 border-top pt2'>
          <div className='ItemContent px1 py1 border-light-grey4 rounded'>
            {integration ? (
              <p className='mt1 font-dark-grey h5'>{integration.name}</p>
            ) : (
              <div className='mt1 font-dark-grey h5 p3 flex items-center justify-center'>
                No Integration Configured.
              </div>
            )}
          </div>
        </div>
      </div>
    </FloatingForm>
  )
}

export default ProductInfoPane



// WEBPACK FOOTER //
// ./src/components/products/details/product/details/pane/ProductIntegration.tsx